import React, {Component} from 'react';
import axios from 'axios';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import {convertBytesToString} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {tableStyles} from "../shared/styles-table";
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';

/**
 * Report Jobs class for retrieving and downloading Job files
 *
 */
export class ReportJobsDownloadFiles extends Component {
    constructor(props) {
        super(props);
        const disabled = (props.disabled === true);
        const id = (props.id) ? props.id : '';
        const name = (props.name) ? props.name : id;
        const jobType = (props.type) ? props.type : '';
        const jobCreated = (props.created) ? props.created : '';
        const fileList = (props.files && props.files.length > 0) ? props.files : [];
        const file = (fileList.length > 0) ? fileList[0] : null;
        this.state = {
            created: jobCreated,
            dialogOpen: false,
            disabled: disabled,
            icon: 'download',
            id: id,
            jobName: name,
            jobType: jobType,
            file: file,
            fileList: fileList,
            name: name
        };

        this.downloadFile = this.downloadFile.bind(this);
        this.processFilesData = this.processFilesData.bind(this);
        this.handleDownloadClick = this.handleDownloadClick.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.disabled !== this.props.disabled) {
            this.setState({
                disabled: nextProps.disabled
            });
        }
        if (nextProps.id !== this.props.id) {
            this.setState({
                file: null,
                id: nextProps.id
            });
        }
        if (nextProps.name !== this.props.name) {
            this.setState({
                file: null,
                jobName: nextProps.name
            });
        }
        if (nextProps.type !== this.props.type) {
            this.setState({
                file: null,
                jobType: nextProps.type
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.files) !== JSON.stringify(this.props.files)) {
            this.processFilesData(this.props.files);
        }
    }

    processFilesData = (data) => {
        let fileList = [];
        let file = null;
        let icon = 'download';
        const jobName = this.state.jobName;
        for (let i = 0; i < data.length; i++) {
            let file = data[i];
            if (file.filename === '' || file.size === 0) {
                continue;
            }
            file.extension = (file.filename) ? file.filename.substring(file.filename.indexOf('.') + 1) : 'csv';
            // Format the Report name and reformat dates
            file.file_safe_name = this.state.jobName.replace(/[^a-zA-Z0-9 ]/g, '').replace(/ +/g, '-');
            if (file.file_safe_name.includes('-formatted-on') && jobName.includes('/')) {
                const formattedIdx = file.file_safe_name.indexOf('-formatted-on');
                if (formattedIdx !== -1) {
                    const dateStr = file.file_safe_name.substring(formattedIdx + 14);
                    const newDateStr = dateStr.substring(dateStr.length - 4).toString() + dateStr.substring(0, dateStr.length - 6).toString() + dateStr.substring(dateStr.length - 6, dateStr.length - 4).toString();
                    file.file_safe_name = file.file_safe_name.substring(0, formattedIdx) + '-' + newDateStr;
                }
            } else {
                const created = new Date(this.state.created);
                file.file_safe_name = file.file_safe_name + '-' + created.getFullYear().toString() + (created.getMonth() + 1).toString() + created.getDate().toString();
            }

            file.file_size = convertBytesToString(file.size);
            file.job_type = this.state.jobType;
            // Create a filename from the formatted Job name and the filename sans UUID
            let downloadFilename = file.file_safe_name;
            const strippedFilename = file.filename.substring(36);
            if (!strippedFilename.startsWith('.') && !strippedFilename.startsWith('-')) {
                downloadFilename += '-';
            }
            file.display_name = strippedFilename.substring(1);
            downloadFilename += strippedFilename;
            file.download_filename = downloadFilename.toLowerCase();
            fileList.push(file);
        }
        if (fileList.length === 0) {
            icon = 'error';
        }
        // If only one file exists, download it directly
        if (fileList.length === 1) {
            file = fileList[0];
        }

        this.setState({
            icon: icon,
            file: file,
            fileList: fileList
        });
    };

    downloadFile = (file) => {
        this.setState({
            icon: 'loading'
        });
        let contentType = '';
        let resource = reportsResources.ReportJobDownload.GET_ONE({filename: file.filename});
        let headers = getGetHeaders();

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: headers,
            responseType: 'arraybuffer'
        }).then((result) => {
            if (result && result.data) {
                const requestType = result.request['content-type'];
                if (file.extension === 'pdf') {
                    contentType = 'application/pdf';
                } else if (file.extension === 'csv') {
                    contentType = 'text/csv;charset=utf-8';
                } else if (file.extension === 'xls') {
                    contentType = 'application/octet-stream';
                    // application/vnd.sealed.xls
                    // data:application/vnd.ms-excel;base64
                    // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;
                } else {
                    contentType = requestType;
                }
                const blob = new Blob([result.data], {type: contentType});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = file.download_filename;
                link.target = '_blank';
                link.title = file.download_filename;
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                setTimeout(function () {
                    // Delay revoking ObjectURL (Firefox)
                    window.URL.revokeObjectURL(url);
                }, 100);
                link.remove();
                this.setState({
                    icon: 'download'
                });
            }
        }).catch((error) => {
            console.log('Download File Error: ', error);
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error: ', error.message);
            }
            this.setState({
                icon: 'download'
            });
        });
    };

    openDialog = () => {
        this.setState({
            dialogOpen: true
        });
    };

    closeDialog = () => {
        this.setState({
            dialogOpen: false
        });
    };

    handleDownloadClick = () => {
        if (this.state.file) {
            // If one file exists for this Job, download it
            this.downloadFile(this.state.file);
        } else if (this.state.fileList.length > 1) {
            // If multiple files exist for this Job, open the dialog to display options
            this.openDialog();
        }
    };

    renderFileRows = (list) => {
        return (
            list.map((item) => <TableRow key={`file-download-row-${item.filename}`}>
                <TableRowColumn>{item.display_name}</TableRowColumn>
                <TableRowColumn>
                    <FlatButton
                        label="Download"
                        icon={<DownloadIcon/>}
                        primary={true}
                        onClick={() => this.downloadFile(item)}
                    />
                </TableRowColumn>
            </TableRow>)
        )
    };

    render() {

        const {
            dialogOpen,
            disabled,
            fileList,
            icon,
            jobName
        } = this.state;

        return (
            <span>
                {icon === 'download' &&
                    <DownloadIcon
                        onClick={() => this.handleDownloadClick()}
                        style={(disabled) ? tableStyles.disabledTableIconButton : tableStyles.tableIconButton}
                    />
                }
                {icon === 'loading' &&
                    <CircularProgress
                        className="app-loader"
                        size={20}
                        thickness={3}
                        style={tableStyles.tableIconLoader}
                    />
                }
                {icon === 'error' &&
                    <ErrorIcon style={tableStyles.disabledTableIconButton}/>
                }

                <Dialog
                    modal={false}
                    open={dialogOpen}
                    onRequestClose={() => this.closeDialog()}
                    autoScrollBodyContent={true}
                    actions={[
                        <FlatButton
                            label="Close"
                            primary={true}
                            onClick={() => this.closeDialog()}
                        />
                    ]}
                    contentStyle={{width: '85%', maxWidth: '90%'}}
                >
                    <h3 className="dialog-title">Download Report Job "{jobName}"</h3>
                    <Table selectable={false} multiSelectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn>Files ({fileList.length})</TableHeaderColumn>
                            <TableHeaderColumn>Download</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                    {[...this.renderFileRows(fileList)]}
                    </TableBody>
                    </Table>
                </Dialog>
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsDownloadFiles.js